<template>
  <div class="d-flex flex-column align-center justify-center w-100 ga-4 text-center">
    <h1 class="text-title-color">
      <slot name="title"></slot>
    </h1>
    <p class="text-title-color font-size-18">
      <slot name="text"></slot>
    </p>
    <div class="d-flex flex-column align-center justify-center ga-2 text-center mt-3">
      <div class="text-title-color font-size-16">Questions? Message us on WhatsApp</div>
      <div class="text-title-color font-size-18 font-weight-800">+353 (0)83 123 4000</div>
      <burton class="whats-app-btn" @click="openWhatsApp"> <VIcon icon="mdi-whatsapp"></VIcon> WhatsApp </burton>
      <p><i>(No calls please)</i></p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ThankYouComponent',
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    openWhatsApp() {
      const url = 'https://api.whatsapp.com/send?phone=353831234000';
      window.open(url, '_blank', 'noreferrer');
    }
  }
};
</script>
